import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            精选推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            编辑团队每日精选优质国产影视内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) {
                      const placeholder = parent.querySelector('.img-placeholder');
                      if (placeholder) (placeholder as HTMLElement).style.display = 'flex';
                    }
                  }}
                />
                <div className="img-placeholder hidden w-full aspect-video bg-background-200 flex items-center justify-center">
                  <i className="ri-movie-line text-3xl text-foreground-400"></i>
                </div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    <i className="ri-play-fill text-primary-600 text-xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.desc}</p>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="whitespace-nowrap">{item.duration}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}